/**
 * Marks method as deprecated and logs a warning once when it is called.
 * @param deprecation_info - Information about the deprecation, such as the new method to be used instead.
 * @note target_or_deprecation_info allows the decorator to be used as a function, so it can be used like this: `@Deprecated` or like this: `@Deprecated({ new: 'NewMethod' })`
 */
export function Deprecated(target_or_deprecation_info, property_key, descriptor) {
    if (descriptor && property_key) {
        // Directly applied as a decorator without being called as a function
        return handle_decorator(target_or_deprecation_info, property_key, descriptor);
    }
    // Called as a function, so it returns the actual decorator.
    // It is safe to assume that target_or_deprecation_info is DeprecationInfo.
    return function (target, propertyKey, descriptor) {
        return handle_decorator(target, propertyKey, descriptor, target_or_deprecation_info);
    };
}
// Function that actually handles the decorator
function handle_decorator(_, property_key, descriptor, deprecation_info) {
    let warned = false;
    // Method decorator
    if (descriptor.value) {
        const original_method = descriptor.value;
        descriptor.value = function (...args) {
            if (!warned) {
                warning_log(property_key, deprecation_info);
                warned = true;
            }
            return original_method.apply(this, args);
        };
        // Setter decorator
    }
    else if (descriptor.set) {
        const original_setter = descriptor.set;
        descriptor.set = function (value) {
            if (!warned) {
                warning_log(property_key, deprecation_info);
                warned = true;
            }
            original_setter.call(this, value);
        };
    }
    return descriptor;
}
function warning_log(property_key, deprecation_info) {
    let warning_message = `${property_key} is deprecated and will be removed in a future version.`;
    if (deprecation_info) {
        warning_message += ` Please use ${deprecation_info.new} instead.`;
    }
    console.warn(warning_message);
}
export function deprecate(fn, function_name, deprecation_info) {
    let warned = false;
    return function (...args) {
        if (!warned) {
            warning_log(function_name !== null && function_name !== void 0 ? function_name : fn.name, deprecation_info);
            warned = true;
        }
        return fn.apply(this, args);
    };
}
//# sourceMappingURL=Deprecated.js.map